/**
 * 설정 파일을 로드하고 내보냅니다.
 * 기본적으로 config.json을 로드하고, 환경 변수에 설정된 값이 있으면 적용합니다.
 * 최종적으로 S3 설정이 있으면 이것이 가장 높은 우선순위로 덮어씁니다.
 */
import configJson from './config.json';

// 기본 설정 로드
const defaultConfig = {
  ...configJson
};

// 환경 변수에서 설정값 가져오기
const loadedConfig = {
  ...defaultConfig,
  // 모든 환경 변수는 import.meta.env로 접근 가능
  APPLICATION_START_DATE: import.meta.env.APPLICATION_START_DATE || defaultConfig.APPLICATION_START_DATE,
  APPLICATION_CLOSE_DATE: import.meta.env.APPLICATION_CLOSE_DATE || defaultConfig.APPLICATION_CLOSE_DATE,
  CONFIG_S3_URL: import.meta.env.CONFIG_S3_URL,
  API_URL: import.meta.env.API_URL
};

// 설정 내보내기
export const config = loadedConfig;

// 콘솔에 로그 출력 (개발 시 확인용)
console.log('🔧 설정 로드 완료 (S3 적용 전 기본값):', JSON.stringify({
  APPLICATION_START_DATE: config.APPLICATION_START_DATE,
  APPLICATION_CLOSE_DATE: config.APPLICATION_CLOSE_DATE,
  CONFIG_S3_URL: config.CONFIG_S3_URL || '설정되지 않음',
  API_URL: config.API_URL || '설정되지 않음'
}, null, 2));

// 기본 내보내기
export default config; 